import { Component, EventEmitter, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { PrimeNGConfig, MessageService } from 'primeng/api';
import { MenuService, AppDataService, ConfigService, XpressUserService } from 'app/services';
import { Utils } from 'app/utils';
import * as moment from 'moment';
import { MenuPermissionActionEnum, MenuPermissionConfig, RootMenuEnum, XpressUserRoleEnum } from 'app/models';
import { XpressTopbarComponent } from 'app/layout';
import { HomeRootComponent, MenuHomeEnum } from 'app/home';
import { OpsTowerRootComponent } from 'app/ops-tower';
import { BackOfficeRootComponent } from 'app/back-office';
import { MarketingRootComponent } from 'app/marketing';
import { BehaviorSubject } from 'rxjs';
import { skip } from 'rxjs/operators';
import { PartnerRootComponent } from 'app/partner/partner-root.component';
import { PartnerOrdersRootComponent } from 'app/partner/partner-orders/partner-orders-root/partner-orders-root.component';
import { PartnerMarketingRootComponent } from 'app/partner/partner-marketing/partner-marketing-root/partner-marketing-root.component';
import { PartnerInsightsRootComponent } from 'app/partner/partner-insights/partner-insights-root/partner-insights-root.component';
import { PartnerSettingsRootComponent } from 'app/partner/partner-settings/partner-settings-root/partner-settings-root.component';
import { PartnerMartLocationsRootComponent } from 'app/partner/mart/partner-mart-locations/partner-mart-locations-root/partner-mart-locations-root.component';
import { PartnerDashboardSwitchComponent } from 'app/partner/partner-dashboard/partner-dashboard-switch/partner-dashboard-switch.component';
import { SideMenuReportEnum } from './components/report/side-menu-report.enum';
import { RouteObserverService } from './services/utils/route-observer.service';

export enum RootEnum {
    None = 0,
    Home = 1,
    OpsTower = 2,
    BackOffice = 3,
    RegistrationVehicles = 4,
    Marketing = 5,
    LGU = 6,
    Comms = 7,
    Report = 8,
    Finances = 9,
    Settings = 10,
    Audit = 11,
    OperatorLogin = 12,
    OperatorSignUp = 13,
    OperatorDashboard = 14,
    OperatorReports = 15,
    OperatorFinance = 16,
    PartnerHome = 17,
    PartnerOrders = 18,
    PartnerLocations = 19,
    PartnerMarketing = 28,
    PartnerFinanceReports = 20,
    PartnerInsights = 21,
    PartnerSettings = 22,
    PartnerDashboardSwitch = 23,
    PartnerLogin = 24,
	PartnerMenu = 25,
	Experience = 26,
    Sandbox = 27,
}

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

    private prevRouterPath: string;

    private getAuthDataPromise: Promise<any> | undefined;

    menuMode = 'sidebar';

    darkMode = 'light';

    topbarTheme = 'light';

    menuTheme = 'dark';

    inputStyle = 'outlined';

    ripple: boolean = false;

    sidebarStatic: boolean = false;

    sidebarActive = false;

    staticMenuMobileActive: boolean = false;

    menuClick: boolean = false;

    topbarItemClick: boolean = false;

    activeTopbarItem: any;

    topbarMenuActive: boolean = false;

    searchClick = false;

    search = false;

    rightPanelClick: boolean = false;

    rightPanelActive: boolean = false;

    configActive: boolean = false;

    configClick: boolean = false;

    menuHoverActive = false;

    tourOperatorLogin = false;
    merchantLogin = false;
    operatorLogin = false;
	operatorSignUp = false;
	isStateBased = false;

    public permissionsSubject = new BehaviorSubject<any>({});
    permissions$ = this.permissionsSubject.asObservable();
    private defaultPage = 'home-dashboard';

    protected readonly RootEnum = RootEnum;
    public menuEnum = RootEnum;
    public activeRoot!: RootEnum;
    isProfileVisible: boolean = false;
    isXpressAdminRoute: boolean = false;

    @ViewChild(XpressTopbarComponent)
    public xpressTopbarComponent!: XpressTopbarComponent;

    @ViewChild(forwardRef(() => OpsTowerRootComponent))
    opsRoot!: OpsTowerRootComponent;

    @ViewChild(BackOfficeRootComponent)
    backOfficeRoot!: BackOfficeRootComponent;

    @ViewChild(MarketingRootComponent)
    marketingRoot!: MarketingRootComponent;

    @ViewChild(PartnerRootComponent)
    partnerRoot!: PartnerRootComponent;

    @ViewChild(PartnerOrdersRootComponent)
    partnerOrdersRoot!: PartnerOrdersRootComponent;

    @ViewChild(PartnerMartLocationsRootComponent)
    partnerLocationsRoot!: PartnerMartLocationsRootComponent;

    @ViewChild(PartnerMarketingRootComponent)
    partnerMarketingRoot!: PartnerMarketingRootComponent;

    @ViewChild(PartnerInsightsRootComponent)
    partnerInsightsRoot!: PartnerInsightsRootComponent;

    @ViewChild(PartnerSettingsRootComponent)
    partnerSettingsRoot!: PartnerSettingsRootComponent;

    @ViewChild(PartnerDashboardSwitchComponent)
    partnerDashboardSwitch!: PartnerDashboardSwitchComponent;

    constructor(
        private router: Router,
        private primengConfig: PrimeNGConfig,
        private menuService: MenuService,
        private appData: AppDataService,
        private configService: ConfigService,
        private xpressUserService: XpressUserService,
        private messageService: MessageService,
        private routeObserverService: RouteObserverService) {
		this.prevRouterPath = '';

        // TODO: what is this for? may be use appData?
        localStorage.removeItem('reviewMerchantId');

        this.tourOperatorLogin = sessionStorage.getItem('tourOperatorLogin') as unknown as boolean;
        this.merchantLogin = sessionStorage.getItem('merchantLogin') as unknown as boolean;
        this.operatorLogin = sessionStorage.getItem('operatorLogin') as unknown as boolean;
        this.operatorSignUp = sessionStorage.getItem('operatorSignUp') as unknown as boolean;

        const currentPath = this.currentPathname();
        const isOperatorModuleRoute = currentPath.startsWith('/operator');
        if (isOperatorModuleRoute) {
            window.sessionStorage.removeItem('operatorLogin');
            window.sessionStorage.removeItem('operatorSignUp');
            this.operatorLogin = false;
            this.operatorSignUp = false;
        } else if (this.operatorLogin) {
            window.sessionStorage.removeItem('operatorSignUp');
            this.activeRoot = RootEnum.OperatorLogin;
            return;
        } else if (this.operatorSignUp) {
            window.sessionStorage.removeItem('operatorLogin');
            this.activeRoot = RootEnum.OperatorSignUp;
            return;
        } else if (this.merchantLogin) {
            window.sessionStorage.removeItem('merchantLogin');
            this.activeRoot = RootEnum.PartnerLogin;
            return;
        } else if (this.tourOperatorLogin) {
            window.sessionStorage.removeItem('tourOperatorLogin');
            this.activeRoot = RootEnum.PartnerLogin;
            return;
        }
        //Remove this code after admin is fully migrated to use angular routes
        const isRegionModuleRoute = currentPath.startsWith('/region');
        const isOpsTowerModuleRoute = currentPath.startsWith('/opstower');
		if (!isRegionModuleRoute && !isOpsTowerModuleRoute && !isOperatorModuleRoute && (!this.appData.authData.UserId || this.appData.authData.UserId === '0')) {
            this.redirectTo('/Xpress/Login');
            return;
        }

        Utils.checkConversationId();
    }

    processAuthentication(xpressAuth: any) {
        const localStorageAuthData = JSON.parse(xpressAuth);

        const expDateUtc = localStorageAuthData['.expires'];
        const expirationDate = moment(moment.utc(expDateUtc).toDate()).toDate();
        // If session is expired
        if (new Date() >= expirationDate) {
            window.location.href = '/Xpress/Login';
            return;
        }

        // Set access_token from localStorage
        this.appData.authData.access_token = localStorageAuthData.access_token;

        // Get AuthData from server by token
        this.getAuthDataPromise = this.xpressUserService.getAuthData(this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.appData.authData = data;

                // Set access_token from localStorage
                this.appData.authData.access_token = localStorageAuthData.access_token;

                if (this.appData.isMerchant()) {
                    this.appData.activeRootMenu = RootMenuEnum.Partner;
                    this.appData.xpressUserRoleId = XpressUserRoleEnum.Merchant;
                }
                else {
                    this.appData.activeRootMenu = RootMenuEnum.Admin;
                    this.appData.xpressUserRoleId = +this.appData.authData.roleId;

                    const isSignup = sessionStorage.getItem('isSignup') as unknown as boolean;
                    if (!isSignup && this.appData.authData.roleId === XpressUserRoleEnum.Operator.toString()) {
                        this.goToOperatorsRoute();
                    }
                }
                this.onPermissionStateChange(this.appData.authData.Permissions);
            });
    }

    onPermissionStateChange(key: any) {
        this.permissionsSubject.next(key);
    }

	ngOnInit(): void {
        this.routeObserverService.routerObserver.subscribe(route =>{
            this.goToMenuRoute(route);
        });
        // Monitor route changes to determine if we're on xpressadmin routes
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.updateIsXpressAdminRoute(event.url.split('?')[0]);
            }
		});

		const currentPath = this.currentPathname();
		this.updateIsXpressAdminRoute(currentPath);
		if (currentPath.startsWith('/operator')) {
            // AuthInitializer loads authData, but role id was previously only set on
            // non-operator AppComponent paths — keep xpressUserRoleId in sync here.
            if (this.appData.authData?.roleId != null && this.appData.authData.roleId !== '') {
                this.appData.xpressUserRoleId = +this.appData.authData.roleId;
            }
            return;
        }
		if (this.operatorLogin || this.operatorSignUp || this.merchantLogin || this.tourOperatorLogin) {
			this.isXpressAdminRoute = true;
            return;
        }

        if (localStorage.getItem('sidebarStatic') === 'true') {
            this.sidebarActive = true;
            this.sidebarStatic = true;
        }

        // Auth data is now loaded by APP_INITIALIZER
        // Set up user role and permissions
		if (this.appData.isMerchant()) {
			this.isStateBased = true;
            this.appData.activeRootMenu = RootMenuEnum.Partner;
            this.appData.xpressUserRoleId = XpressUserRoleEnum.Merchant;
        }
        else {
            this.appData.activeRootMenu = RootMenuEnum.Admin;
            this.appData.xpressUserRoleId = +this.appData.authData.roleId;

            const isSignup = sessionStorage.getItem('isSignup') as unknown as boolean;
            if (!isSignup && this.appData.authData.roleId === XpressUserRoleEnum.Operator.toString()) {
                this.goToOperatorsRoute();
            }
        }
        this.onPermissionStateChange(this.appData.authData.Permissions);

		if (this.getAuthDataPromise) {
			this.getAuthDataPromise.then(() => this.validateMenu());
		}
		else {
			this.validateMenu();
		}

		// Skip initial BehaviorSubject emission so session restore (validateMenu → goToMenuRoute)
		// is not overwritten before ops-tower-root ViewChild exists.
		this.appData.clientLocationType$.pipe(skip(1)).subscribe(() => {
			if (!this.isMerchant()) {
				this.activeRoot = RootEnum.Home;
			}
        });
	}

	validateMenu() {
		// Only apply automatic navigation if user is on root path or xpressadmin path
		const currentUrl = this.router.url;
		const isOnRootPath = currentUrl === '/';
		if (isOnRootPath) {
			// On first page load open home page
			if (this.appData.xpressUserRoleId === XpressUserRoleEnum.Merchant || this.appData.xpressUserRoleId === XpressUserRoleEnum.TourOperator) {
				this.activeRoot = RootEnum.PartnerDashboardSwitch;
                if (this.appData.xpressUserRoleId === XpressUserRoleEnum.Merchant ) {
                    this.isStateBased = true;
                }
			}
			else if (this.appData.hasPermission(this.defaultPage, MenuPermissionActionEnum.Read)) {
				const previousMenuItem = JSON.parse(sessionStorage.getItem('currentMenuItem') + '');
				if (previousMenuItem) {
					this.goToMenuRoute(previousMenuItem);
				}
				else {
					this.activeRoot = RootEnum.Home;
				}
			} else if (this.appData.xpressUserRoleId === XpressUserRoleEnum.Operator) {
				this.goToOperatorsRoute();
			}
		}
		this.primengConfig.ripple = true;
	}

    goToOperatorsRoute() {
        const currentPath = window.location.pathname;
        if (currentPath.startsWith('/operator/dashboard')) {
            return;
        }

        void this.router.navigate(['/operator/dashboard/home']);
    }

    protected currentPathname(): string {
        return window.location.pathname || '';
    }

    protected redirectTo(url: string): void {
        window.location.href = url;
    }

    private updateIsXpressAdminRoute(path: string): void {
        this.isXpressAdminRoute = !path.startsWith('/region')
            && !path.startsWith('/opstower')
            && !path.startsWith('/operator');
    }

	goToMenuRoute(item: any) {
        this.isProfileVisible = false;
		this.activeRoot = item.root;
		// Pre-migration sessions persisted the state-based Disbursements leaf without a route; replay must reach the routed page, not the retired state host.
		if (!item.route && item.root === RootEnum.Report && item.menuFlag === SideMenuReportEnum.Disbursements) {
			item = { ...item, route: ['/xpressadmin/report/disbursements'] };
		}
		// Pre-migration sessions persisted the state-based Vehicle Upgrades leaf without a route; replay must reach the routed page, not the retired Registration host.
		if (!item.route && item.root === RootEnum.RegistrationVehicles && item.menuFlag === MenuHomeEnum.VehicleUpgrades) {
			item = { ...item, route: ['/xpressadmin/back-office/vehicles/upgrades'] };
		}
		// Pre-migration sessions persisted the Admin-shell Operator leaves without a route;
		// replay must reach the canonical Operator portal, not the retired Admin-shell host.
		if (!item.route && item.root === RootEnum.OperatorDashboard) {
			item = { ...item, route: ['/operator/dashboard/home'] };
		}
		if (!item.route && item.root === RootEnum.OperatorReports) {
			item = { ...item, route: ['/operator/dashboard/reports'] };
		}
		if (!item.route && item.root === RootEnum.OperatorFinance) {
			item = { ...item, route: ['/operator/dashboard/finance'] };
		}
		if (item.route) {
			this.isStateBased = false;
			this.router.navigate(item.route);
			return;
		}

		this.isStateBased = true;
        switch (item.root) {
            case RootEnum.OpsTower: setTimeout(() => { this.opsRoot.clickMenu(item.id, item.menuFlag); }, 200); break;
            case RootEnum.BackOffice: setTimeout(() => { this.backOfficeRoot.clickMenu(item.id, item.menuFlag, item.backOffice); }, 200); break;
            case RootEnum.Marketing: setTimeout(() => { this.marketingRoot.clickMenu(item.id, item.menuFlag); }, 200); break;
            case RootEnum.OperatorReports: break;
            case RootEnum.PartnerDashboardSwitch: setTimeout(() => { this.partnerDashboardSwitch.clickMenu(item.id, item.menuFlag); }, 200); break;
            case RootEnum.PartnerHome: setTimeout(() => { this.partnerRoot.clickMenu(item.id, item.menuFlag); }, 200); break;
            case RootEnum.PartnerOrders: setTimeout(() => { this.partnerOrdersRoot.clickMenu(item.id, item.menuFlag); }, 200); break;
            case RootEnum.PartnerLocations: setTimeout(() => { this.partnerLocationsRoot.clickMenu(item.id, item.menuFlag); }, 200); break;
            case RootEnum.PartnerMarketing: setTimeout(() => { this.partnerMarketingRoot.clickMenu(item.id, item.menuFlag); }, 200); break;
            case RootEnum.PartnerInsights: setTimeout(() => { this.partnerInsightsRoot.clickMenu(item.id, item.menuFlag); }, 200); break;
            case RootEnum.PartnerSettings: setTimeout(() => { this.partnerSettingsRoot.clickMenu(item.id, item.menuFlag); }, 200); break;
        }
    }

    onLayoutClick() {
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
            this.topbarMenuActive = false;
        }

        if (!this.menuClick && (this.isHorizontal() || this.isSlim())) {
            this.menuService.reset();
        }

        if (this.configActive && !this.configClick) {
            this.configActive = false;
        }

        if (!this.rightPanelClick) {
            this.rightPanelActive = false;
        }

        if (!this.menuClick) {
            if (this.staticMenuMobileActive) {
                this.staticMenuMobileActive = false;
            }

            this.menuHoverActive = false;
            this.unblockBodyScroll();
        }

        if (!this.searchClick) {
            this.search = false;
        }

        this.searchClick = false;
        this.configClick = false;
        this.topbarItemClick = false;
        this.menuClick = false;
        this.rightPanelClick = false;
    }

    onMenuButtonClick(event: Event) {
        this.menuClick = true;
        this.topbarMenuActive = false;
        this.rightPanelActive = false;

        if (this.isMobile()) {
            this.staticMenuMobileActive = !this.staticMenuMobileActive;
            if (this.staticMenuMobileActive) {
                this.blockBodyScroll();
            } else {
                this.unblockBodyScroll();
            }
        }

        event.preventDefault();
    }

    onTopbarItemClick(event: Event, item: any) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        if (item.className === 'topbar-item search-item') {
            this.search = !this.search;
            this.searchClick = !this.searchClick;
        }

        event.preventDefault();
    }

    onRightPanelClick(event: Event) {
        this.rightPanelClick = true;
        this.rightPanelActive = !this.rightPanelActive;

        this.staticMenuMobileActive = false;

        event.preventDefault();
    }

    onRippleChange(event: any) {
        this.ripple = event.checked;
        this.primengConfig.ripple = event.checked;
    }

    onConfigClick() {
        this.configClick = true;
    }

    onSidebarClick() {
        this.menuClick = true;
    }

    onToggleMenu(event: Event) {
        this.menuClick = true;
        this.sidebarStatic = !this.sidebarStatic;
        localStorage.setItem('sidebarStatic', this.sidebarStatic+'');
        // Copy some AppComponent properties to ConfigService
        this.configService.config.sidebarStatic = this.sidebarStatic;

        event.preventDefault();
    }

    onSidebarMouseOver() {
        if(this.isMerchant()){
            return;
        }

        if (this.menuMode === 'sidebar' && !this.sidebarStatic) {
            this.sidebarActive = !this.isMobile();
        }
    }

    onSidebarMouseLeave() {
        if (this.menuMode === 'sidebar' && !this.sidebarStatic) {
            setTimeout(() => {
                this.sidebarActive = false;
            }, 250);
        }
    }

    isSlim() {
        return this.menuMode === 'slim';
    }

    isHorizontal() {
        return this.menuMode === 'horizontal';
    }

    isDesktop() {
        return window.innerWidth > 991;
    }

    isMobile() {
        return window.innerWidth <= 991;
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    changeProfileVisible(event: boolean): void {
        this.isProfileVisible = event;
        if(!this.isProfileVisible){
            const previousMenuItem = JSON.parse(sessionStorage.getItem('currentMenuItem') + '');
            if (previousMenuItem) {
                this.goToMenuRoute(previousMenuItem);
            }
        }
    }

    isMerchant() {
        return +this.appData.authData.roleId === XpressUserRoleEnum.Merchant;
    }
}
